import axios from "../axios";
const END_POINT = "/provinces";

const addProvince = (province) => axios.post(`${END_POINT}`, province);
const getAllProvinces = (payload) =>
  axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getOneProvince = (provincesId) =>
  axios.get(`${END_POINT}/${provincesId}`);
const updateProvince = (provinceId, payload) =>
  axios.patch(`${END_POINT}/${provinceId}`, payload);
const searchProvince = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteProvince = (provincesId) =>
  axios.delete(`${END_POINT}/${provincesId}`);

export {
  getAllProvinces,
  addProvince,
  getOneProvince,
  updateProvince,
  searchProvince,
  deleteProvince,
};
